import Vuex from 'vuex'
import Vue from 'vue'
import snackbar from './modules/snackbar'
import pageLoader from './modules/pageLoader'
import userModule from './modules/user'
import overviewModule from './modules/overview'
import metadataModule from './modules/metadata'
import uploadModule from './modules/upload'
import mediaSourceModule from './modules/mediaSources'
import itemModule from './modules/items'
import instanceModule from './modules/instances'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    snackbar,
    pageLoader,
    users: userModule,
    overviews: overviewModule,
    metadata: metadataModule,
    upload: uploadModule,
    mediaSources: mediaSourceModule,
    items: itemModule,
    instances: instanceModule,
  },
})
